import React from 'react';
import Blocks from './Blocks';
import { IPageFields } from '@/types/contentful';

export function AltHeroBlock({ altHeroBlock }: IPageFields) {
  const { sys, fields } = altHeroBlock ?? {};

  if (!altHeroBlock) {
    return null;
  }

  return (
    <div className="mb-20 tablet:mb-[120px]">
      <Blocks sys={sys} fields={fields} />
    </div>
  );
}
